module.exports = __webpack_public_path__ + "img/154a3ac.png";